import axios from 'axios';

const curretUrl = () => [window.location.protocol, '//', window.location.host].join('');
const loginUrl = () => `${ process.env.VUE_APP_API_URL }/Auth/Logon?callback=${ encodeURIComponent(curretUrl()) }`;
const logoutUrl = () => `${ process.env.VUE_APP_API_URL }/Auth/Logoff`;

/* const logout = () => axios({
    method: 'get',
    url: `${ process.env.VUE_APP_API_URL }/Auth/Logoff`,
    withCredentials: true,
}); */

const verify = () => axios({
    method: 'get',
    url: `${ process.env.VUE_APP_API_URL }/Auth/Me`,
    withCredentials: true,
});

export default {
    loginUrl,
    logoutUrl,
    verify,
};
